import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import profileSVG2 from '../Assets/profileSVG2.svg'
import { apiGet, apiputFormData } from '../ApiUrls';
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom';
import WhatsAppButton from '../Components/WhatsAppButton';

function Profile() {
  const navigate = useNavigate()
  const [firstName, setFirstName] = useState("Rahesh");
  const [lastName, setLastName] = useState("Sharma");
  const [email, setEmail] = useState("rahesh@gmail.com");
  const [Number, setNumber] = useState("9651879654");
  const [address, setAddress] = useState("31, Dwarka Dham Colony, Mangliya");
  const [ProfileImage, setProfileImage] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const [isLoggedIn, setIsLoggedIn] = useState(false);


  useEffect(() => {
    const storedUser = localStorage.getItem("user") || {};
    const storedToken = localStorage.getItem("userToken");
    if (storedUser && storedToken) {
      setIsLoggedIn(true);
    }
  }, []);

  const [Userprofile, setUserprofile] = useState({});
  const [IsUploading, setIsUploading] = useState(false);

  const GetUserprofile = async () => {
    try {
      setIsUploading(true)
      const response = await apiGet(`api/user/GetUserProfile`)
      setUserprofile(response?.data)
      setFirstName(response?.data?.FirstName);
      setLastName(response?.data?.LastName);
      setEmail(response?.data?.Email);
      setNumber(response?.data?.Number);
      setAddress(response?.data?.Address);
      setProfileImage(response?.data?.ProfileImage);
      setIsUploading(false)
    } catch (error) {
      setIsUploading(false)
      console.log(error)
    }
  }

  useEffect(() => {
    if (isLoggedIn) {
      GetUserprofile();
    }
  }, [isLoggedIn]);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
      setProfileImage(file);
    }
  };

  const handleProfileUpdate = async (event) => {
    event.preventDefault();
    try {
      setIsUploading(true);
      const formData = new FormData();
      formData.append('FirstName', firstName);
      formData.append('LastName', lastName);
      formData.append('Email', email);
      formData.append('Number', Number);
      formData.append('Address', address);
      if (ProfileImage) {
        formData.append('Image', ProfileImage);
      }
      const response = await apiputFormData('api/user/UpdateUser', formData);
      toast.success(response?.message);
      GetUserprofile();
    } catch (error) {
      console.log(error);
      toast.error('Failed to update profile');
    } finally {
      setIsUploading(false);
    }
  };


  const Logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('userType');
    localStorage.removeItem('userid');
    localStorage.removeItem('userToken');
    toast.success('Logged out successfully!');
    navigate('/')
  }


  return (
    <>
      <Navbar />
      <>
        <div className="Profile-header">
          <h1>Profile</h1>
          <p>
            Home / <span className="active">Profile</span>
          </p>
        </div>
        <br />
        <div className="profile-container">
          <div className='profile-main'>
            <h1 className="profile-title">My Profile</h1>
            <p className="profile-subtitle">
              Update your profile, contact details, and preferences to personalize your experiences.
            </p>
            <br />
            <br />
            <div className="profile-header">
              <div>
                <img src={selectedImage || ProfileImage || profileSVG2} alt="Profile" className="profile-img" />
                <p>{firstName}{lastName}</p>
                <p>{email}</p>
              </div>
              <div className="profile-buttons">
                <input
                  type="file"
                  accept="image/*"
                  id="imageUpload"
                  style={{ display: "none" }}
                  onChange={handleImageChange}
                />
                <button
                  className="upload-btn"
                  onClick={() => document.getElementById("imageUpload").click()}
                >
                  📤 Upload Image
                </button>
                <button onClick={() => setSelectedImage(null)} className="remove-btn">🗑 Remove</button>
              </div>
            </div>
            <div className="tab-container">
              <button className="tab active">Change Profile</button>
              <button className="tab">My Properties</button>
            </div>
            <div className="profile-form">
              <div className="input-group">
                <label>First name</label>
                <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
              </div>
              <div className="input-group">
                <label>Last name</label>
                <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
              </div>
              <div className="input-group">
                <label>Email</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
              </div>
              <div className="input-group">
                <label>Phone number</label>
                <input type="text" value={Number} onChange={(e) => setNumber(e.target.value)} />
              </div>
              <div className="input-group">
                <label>Address</label>
                <input type="text" value={address} onChange={(e) => setAddress(e.target.value)} />
              </div>
              <div className='profile-header'>
                <button disabled={IsUploading} onClick={(e) => { handleProfileUpdate(e) }} className="save-btn">{IsUploading ? 'Saving...' : 'Save'}</button>
                <button onClick={(e) => { Logout() }} className="save-btn">Logout</button>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
      </>
      <WhatsAppButton/>
      <Footer />
    </>
  )
}

export default Profile
